import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import {extractGtin14FromBarcode} from '../helpers/gs1Barcode';

export async function searchOrderByBarcode(input) {
  const data = {
    input: input,
    state: 'scanpack.rfo',
    id: null,
    box_id: null,
    store_order_id: null,
    app: 'app'
  };

  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');

  const res = await axios({
    method: 'post',
    url: `${url}/scan_pack/scan_barcode.json`,
    headers: {Authorization: `Bearer ${access_token}`},
    data: data
  });

  return res;
}

export async function checkConfirmationCodeForServiceIssue(confirmation_code) {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');

  const res = await axios({
    method: 'get',
    url: `${url}/users/1/?confirmation_code=${confirmation_code}&format=json`,
    headers: {Authorization: `Bearer ${access_token}`},
    confirmation_code: confirmation_code
  });

  return res;
}

export async function removeFromBox(boxId, orderItemId, kitProductId) {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');

  let apiUrl = `${url}/box/remove_from_box.json?box_id=${boxId}&order_item_id=${orderItemId}`;
  if (kitProductId) {
    apiUrl += `&kit_product_id=${kitProductId}`;
  }

  const res = await axios({
    method: 'put',
    url: apiUrl,
    headers: {Authorization: `Bearer ${access_token}`}
  });

  return res;
}

export const HOLD_NOT_FULFILLED_TIMEOUT_MS = 10000;

export async function holdOrderItemNotFulfilled(orderItemId, productId) {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');

  const res = await axios({
    method: 'post',
    url: `${url}/scan_pack/order_item_out_of_stock.json`,
    headers: {Authorization: `Bearer ${access_token}`},
    data: {order_item_id: orderItemId, product_id: productId, option: 'hold_item'},
    timeout: HOLD_NOT_FULFILLED_TIMEOUT_MS
  });

  return res;
}

export async function searchProductByBarcode(barcode) {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');
  const gtin14 = extractGtin14FromBarcode(barcode);
  const res = await axios({
    method: 'get',
    url: `${url}/products/search.json?barcode=${gtin14 || barcode}&search=test`,
    headers: {Authorization: `Bearer ${access_token}`}
  });
  return res;
}

export async function fetchShipmentData(storeId, orderId) {
  const access_token = await AsyncStorage.getItem('access_token');
  const url = await AsyncStorage.getItem('url');
  const res = await axios({
    method: 'post',
    url: `${url}/scan_pack/get_shipment.json`,
    headers: {Authorization: `Bearer ${access_token}`},
    data: { store_id: storeId, order_id: orderId }
  });
  return res;
}

export async function getUserInfoFromStorage() {
  const userInfoString = await AsyncStorage.getItem('userInfo');
  return userInfoString ? JSON.parse(userInfoString) : null;
}

